export const users = [
  {
    username: process.env.REACT_APP_USER,
    password: process.env.REACT_APP_PASS,
  },
];
